"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearAll = void 0;

var react_1 = __importDefault(require("react"));

var SelectedFilters_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/basic/SelectedFilters"));

var components_1 = require("../../components");

var hooks_1 = require("../../hooks");

var ClearAll = function ClearAll(props) {
  var _a;

  var RenderComponent = (_a = props.render) !== null && _a !== void 0 ? _a : components_1.ExampleClearAll;
  var filtersHook = (0, hooks_1.useFilters)();
  return react_1.default.createElement(SelectedFilters_1.default, {
    render: function render(renderProps) {
      var selectedFilters = Object.values(renderProps.selectedValues).map(function (value) {
        return value;
      }).filter(function (item) {
        var _a, _b;

        return (item === null || item === void 0 ? void 0 : item.URLParams) && (item === null || item === void 0 ? void 0 : item.showFilter) && (!!((_a = item === null || item === void 0 ? void 0 : item.value) === null || _a === void 0 ? void 0 : _a.length) || !!((_b = item === null || item === void 0 ? void 0 : item.value) === null || _b === void 0 ? void 0 : _b.label));
      });

      var handleClearAll = function handleClearAll() {
        var _a;

        var _iterator = _createForOfIteratorHelper((_a = filtersHook.filters) !== null && _a !== void 0 ? _a : []),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var filter = _step.value;

            if (filter.displayType === "slider") {
              var event = new CustomEvent("@usereactify/search:filter:".concat(filter.handle, ":update"), {
                detail: {
                  handle: filter.handle,
                  value: []
                }
              });
              window.dispatchEvent(event);
            }

            if (filter.displayType === "multi") {
              if (filter.displayView === "range") {
                var _event = new CustomEvent("@usereactify/search:filter:".concat(filter.handle, ":update"), {
                  detail: {
                    handle: filter.handle,
                    value: []
                  }
                });

                window.dispatchEvent(_event);
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        renderProps.clearValues();
      };

      if (props.showWhenEmpty !== true && !selectedFilters.length) {
        return null;
      }

      return react_1.default.createElement(RenderComponent, {
        clearAll: handleClearAll
      });
    }
  });
};

exports.ClearAll = ClearAll;